import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/RootHome/layout";
import LoginForm from "./components/UserAuth/Login";
import './assets/css/master.css';
import { useAuth } from "./components/UserAuth/AuthContext";
import { verifyToken } from "./components/UserAuth/loginApi";
import FullPageLoader from "./components/common/FullPageLoader";
import useOnlineStatus from "./components/common/useOnlineStatus";

const App = () => {
  const isOnline = useOnlineStatus();
  const { userData } = useAuth();

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);

  const handleOfflineAction = () => {
    alert("You are currently offline. Please check your internet connection.");
  };

  const handleOnlineAction = () => {
    alert("You are back online!");
  };

  useEffect(() => {
    const checkLoginStatus = async () => {
      if (userData && userData.token) {
        try {
          await verifyToken();
          setIsLoggedIn(true);
        } catch (error) {
          setIsLoggedIn(false);
        }
      } else {
        setIsLoggedIn(false);
      }
      setLoading(false);
    };

    if (!isOnline) {
      handleOfflineAction();
    } else {
      checkLoginStatus();
    }
  }, [userData, isOnline]);

  // Show loader if still checking token or offline
  if (!isOnline || loading) {
    return <FullPageLoader isloader={true} />;
  }
  

  return (
    <Router>
      <Routes>
        {!isLoggedIn ? (
          <>
            <Route
              path="/login"
              element={<LoginForm onLoginSuccess={() => setIsLoggedIn(true)} onLoginFail={() => setIsLoggedIn(false)} />}
            />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </>
        ) : (
          <>
            <Route
              path="/app/*"
              element={<Layout onLogout={() => setIsLoggedIn(false)} />}
            />
            <Route path="*" element={<Navigate to="/app" replace />} />
          </>
        )}
      </Routes>
    </Router>
  );
};

export default App;
